<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link">
        <template v-if="shellConst.iconPhoto">
          <img
            v-if="shellConst.iconPhoto !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.iconPhoto"
            class="sidebar-logo"
            style="height: 40px"
          />
        </template>
        <template v-else>
          <img
            v-if="shellConst.websiteLogo !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.websiteLogo"
            class="sidebar-logo"
            style="height: 40px"
          />
        </template>
      </div>
      <div v-else key="expand" class="sidebar-logo-link rx-cc">
        <template v-if="shellConst.systemPhoto">
          <img :src="shellConst.systemPhoto" class="sidebar-logo" />
        </template>
        <template v-else-if="shellConst.iconPhoto">
          <img
            v-if="shellConst.iconPhoto !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.iconPhoto"
            class="sidebar-logo"
          />
          <h1 class="sidebar-title">{{ title }}</h1>
        </template>
        <template v-else>
          <img
            v-if="shellConst.websiteLogo !== 'https://common.leqinkeji.com/kanbujian.ico'"
            :src="shellConst.websiteLogo"
            class="sidebar-logo"
          />
          <h1 class="sidebar-title">{{ title }}</h1>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: "服务商管理系统"
    };
  },
  computed: {
    shellConst() {
      return this.$store.state.domain.shellConst;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #0b284a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    gap: 5px;

    & .sidebar-logo {
      height: 55px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family:
        Avenir,
        Helvetica Neue,
        Arial,
        Helvetica,
        sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
